import analytics from '@react-native-firebase/analytics';

import {AnalyticsEvent} from '../events';

import GoogleAnalyticsLogger from './GoogleAnalyticsLogger';

export const GoogleAnalytics: GoogleAnalyticsLogger = {
  logEvent: async (event: AnalyticsEvent) => {
    if (__DEV__) {
      event.parameters.traffic_type = 'internal';
      // TODO traffic type for CI/CD builds
    }

    // TODO validate and sanitise parameter value to follow lower_snake_case
    analytics().logEvent(event.eventName, event.parameters);
  },

  // TODO set on auth
  setUserId: async (userId: string) => analytics().setUserId(userId),

  // TODO clear on logout
  clearUserId: async () => analytics().setUserId(null),

  setUserProperties: async (props: Record<string, unknown>) => analytics().setUserProperties(props),

  setDefaultParameters: async (params: Record<string, unknown>) =>
    analytics().setDefaultEventParameters(params),

  setSessionId: async (id: string) => analytics().setUserProperty('session_id', id),

  clearSessionId: async () => analytics().setUserProperty('session_id', null),

  clearUserSession: async () => {
    GoogleAnalytics.clearUserId();
    GoogleAnalytics.clearSessionId();
  },
};
